import React, { useContext, useState } from 'react';
import { AudioContext } from '../../libs/audio-provider';
import Modal from '../ui/Modal';
import SvgButton from '../ui/SvgButton';

interface GameGunpowderDescriptionProps {
  children?: React.ReactNode;
  style?: React.CSSProperties;
  onFinish: () => void;
}

const StatusMap = {
  '': { className: '', message: null, next: '' },
  'message-1': { className: 'message', message: '火藥是中國古代道士煉丹時，無意中配製出來的易燃爆炸物。<br/>最早出現於唐末，當時士兵以弓箭或拋石機將火孳包投射攻城。<br/>宋代製造「火槍」、「突火槍」、「震天雷」等武器以抵禦外敵。<br/>元代時則發明了火統，它是一種以鐵或銅製造的管型射擊武器，<br/>是世界最早出現的火炮。', next: 'message-2' },
  'message-2': { className: 'message-western', message: '原來火藥威力這麽強大，我長知識了！', next: 'message-3' },
  'message-3': { className: 'message', message: '現在就讓你試試吧！', next: '' },
}

function GameGunpowderDescription(props: GameGunpowderDescriptionProps) {
  const { playClick } = useContext(AudioContext);
  const [status, setStatus] = useState<'message-1' | 'message-2' | 'message-3' | ''>('message-1');

  const ShowModal = () => {
    return <div className={`modal modal-game-gunpowder game-${StatusMap[status].className}`}>
      <button className="button modal-button-close" onClick={() => { playClick(); setStatus(''); props.onFinish(); }}>
        <SvgButton prefix={`${process.env.PUBLIC_URL}/assets/game-gunpowder/close-button`} src1=".svg" src2="-select.svg" alt="關閉"></SvgButton>
      </button>
      <div className="modal-content">
        {null !== StatusMap[status].message ? <p className="message" dangerouslySetInnerHTML={{ __html: StatusMap[status].message as string }}></p> : null}
      </div>
      <button className="button modal-button-next" onClick={() => {
        playClick();
        setStatus(StatusMap[status].next as any);
        if ('' === StatusMap[status].next) {
          props.onFinish();
        }
      }}>
        <SvgButton prefix={`${process.env.PUBLIC_URL}/assets/game-gunpowder/game4-next-button`} src1=".svg" src2="-select.svg" alt="下一頁"></SvgButton>
      </button>
    </div>
  }

  return (
    <>
      {'' !== status
        ? <Modal>
          <ShowModal />
        </Modal>
        : null}
    </>
  )
}

export default GameGunpowderDescription;
